/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/camelcase */
import React, { Component } from 'react';

import { TmCart } from '../../tscapi/model/cart';
import { TmOrder } from '../../tscapi/model/order';
import { TmProduct, TmEdp } from '../../tscapi/model/product';
import { Cookie } from '../../tscapi/utils/cookie';

const cookie: Cookie = new Cookie();
const clientID = 'tsc';

interface MyState {
    widgetConfig: {};
}
interface MyProps {
    detail: TmOrder;
}

export default class TrueFitCheckout extends Component<MyProps, MyState> {
    constructor(props: Readonly<MyProps>) {
        super(props);
    }

    state = {
        widgetConfig: null,
    };

    loadTrueFitLibrary(): void {
        const queryStrings = ['www.tsc.ca', 'origin1.tsc.ca', 'origin1s.tsc.ca'];
        function includes(array, element) {
            return array.indexOf(element) >= 0;
        }
        const pageUrl = window.location.hostname;
        const isProd = includes(queryStrings, pageUrl);
        const environment = isProd ? 'prod' : 'staging';

        /* eslint-disable */
        // prettier-ignore
        (function(r,e,o){
            var w=window,d=document,t,s,x;
            w.tfcapi=t=w.tfcapi||function(){t.q=t.q||[]; t.q.push(arguments);};
            t('init', {storeKey: r, environment: e, ...o});
            x=d.getElementsByTagName('script')[0];
            s=d.createElement('script');
            s.type='text/javascript';s.async=true;
            s.src='https://'+r+'-cdn'+(e==='dev'||e==='staging'?'.'+e:'')+ '.truefitcorp.com/fitrec/'+r+'/js/tf-integration.js';
            x.parentNode.insertBefore(s,x);
          // Don't change anything above this line
          })(clientID,environment,{autoCalculate:false});
        /* eslint-enable */
    }

    configOrderTrackApi(): void {
        const cookie: Cookie = new Cookie();
        let userID = null;
        const language = cookie.Language.toLowerCase();

        if (
            cookie.UserAccessToken != undefined &&
            cookie.UserAccessToken.Token.length > 0 &&
            cookie.UserAccessToken.Edp > 0
        ) {
            userID = cookie.UserAccessToken.Edp;
        }
        const widgetConfig = {
            products: [],
        };
        if (userID) {
            widgetConfig['userId'] = userID;
            widgetConfig['registered'] = userID ? true : false;
        }
        widgetConfig['locale'] = cookie.Language;
        widgetConfig['orderId'] = this.props.detail.OrderedCart.OrderSummary.OrderNo;

        this.props.detail.OrderedCart.CartLines.forEach((product) => {
            const data = { productId: '', colorId: '', quantity: null, price: 0, currency: 'CAD', size: '', sku: null };
            data.productId = product.CartLineItem.ItemNo;
            data.colorId = product.CartLineItem.Style;
            data.quantity = product.InCart.Quantity;
            data.price =
                language == 'en_ca'
                    ? Number(product.InCart.UnitPrice.replace(/[^0-9\.]+/g, ''))
                    : Number(product.InCart.UnitPrice.replace(/[^0-9\,]+/g, '').replace(',', '.'));

            data.size = product.CartLineItem.Size;
            data.sku = product.CartLineItem.UpcNo;
            widgetConfig.products.push(data);
        });

        //console.log(widgetConfig);
        window['tfcapi']('track', 'checkout', widgetConfig);
    }

    componentDidMount() {
        this.loadTrueFitLibrary();
        this.configOrderTrackApi();
    }
    render() {
        return <></>;
    }
}
